// extracted by mini-css-extract-plugin
export var articleQuote = "InTheNews-module--articleQuote--37ec1";
export var button = "InTheNews-module--button--9cc1c";
export var container = "InTheNews-module--container--65dc4";
export var decor = "InTheNews-module--decor--7a97f";
export var inTheNews = "InTheNews-module--inTheNews--8143d";
export var lineAbove = "InTheNews-module--lineAbove--92da7";
export var link = "InTheNews-module--link--51300";
export var logo = "InTheNews-module--logo--1c465";
export var logoList = "InTheNews-module--logoList--a2a35";
export var newsHeading = "InTheNews-module--newsHeading--989c2";
export var newsSources = "InTheNews-module--newsSources--50d75";
export var relativeWrapper = "InTheNews-module--relativeWrapper--4f8f5";
export var tag = "InTheNews-module--tag--d90cd";